import { bulkAnnotateImages, getFileDescriptor } from '@wix/ambassador-media-site-media-v1-file-descriptor/http';
import { ImageAnnotationType } from '@wix/ambassador-media-site-media-v1-file-descriptor/types';
export const fetchMediaFile = async (httpClient, fileId) => {
  try {
    const {
      data
    } = await httpClient.request(getFileDescriptor({
      fileId
    }));
    return data;
  } catch (e) {
    return undefined;
  }
};
export const bulkAnnotateImageForContainsText = async (httpClient, fileId) => {
  try {
    const {
      data
    } = await httpClient.request(bulkAnnotateImages({
      annotationTypes: [ImageAnnotationType.CONTAINS_TEXT],
      fileIds: [fileId],
      overwrite: false,
      returnEntity: true
    }));
    return data;
  } catch (e) {
    return undefined;
  }
};
export const isImageContainsTextFromGetFileDescriptorResponse = file => {
  var _file$file;
  return (_file$file = file.file) == null || (_file$file = _file$file.media) == null || (_file$file = _file$file.image) == null ? void 0 : _file$file.containsText;
};
export const isImageContainsTextFromBulkAnnotateImagesResponse = file => {
  var _file$results;
  return file == null || (_file$results = file.results) == null || (_file$results = _file$results[0].item) == null || (_file$results = _file$results.media) == null || (_file$results = _file$results.image) == null ? void 0 : _file$results.containsText;
};
//# sourceMappingURL=fetch-media-file.js.map